import React from 'react';

const Blog = () => {
    return (
        <div>
        
            <h1>This is blog page......</h1>
            
        </div>
    );
};

export default Blog;